import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import moment from 'moment';

import {
  requestGetNotifications,
  successGetNotifications,
  failureGetNotifications,
  requestSendNotification,
  successSendNotification,
  failureSendNotification
} from './reducer';

import { getApiClient } from '@app/utils/apiUtils';
import { AnyAction } from '@reduxjs/toolkit';

export function* getNotifications(): Generator<any, any, any> {
  try {
    const apiRes = yield call([getApiClient(), 'get'], '/notification', {});

    yield put(successGetNotifications(apiRes?.data?.data ? apiRes?.data?.data : []));
  } catch (err: any) {
    message.error(err.message);

    yield put(failureGetNotifications(err));
  }
}

export function* sendNotifications(action: AnyAction): Generator<any, any, any> {
  try {
    const { notificationBody } = action.payload;

    const apiRes = yield call([getApiClient(), 'post'], '/notification', { ...notificationBody }, {});

    // Show success message with send statistics
    if (apiRes?.data?.data) {
      const { totalEndpoints, successfulSends, message: successMessage } = apiRes.data.data;
      message.success(successMessage || `Notification sent to ${successfulSends}/${totalEndpoints} devices`);
    } else {
      message.success('Notification sent successfully');
    }

    yield call(getNotifications);

    yield put(successSendNotification());
  } catch (err: any) {
    message.error(err.message);

    yield put(failureSendNotification(err));
  }
}

// Individual exports for testing
export default function* notificationContainerSaga() {
  yield takeLatest(requestGetNotifications.toString(), getNotifications);
  yield takeLatest(requestSendNotification.toString(), sendNotifications);
}

export const notificationContainerSagaArr = [
  takeLatest(requestGetNotifications.toString(), getNotifications),
  takeLatest(requestSendNotification.toString(), sendNotifications)
];
